export default function withoutTrailingSlash(url) {
    return url.replace(/\/$/, '');
}
//# sourceMappingURL=index.js.map